import { combineReducers } from 'redux'

import updateData from './updateData'

const analyticsReducer = combineReducers({
	updateData,
})

export default analyticsReducer
